<main
  *ngIf="{
    violations: violations$ | async
  } as STATE"
  class="admin-creation-form"
>
  <custom-modal-card>
    <ng-container header>
      <default-modal-header
        [title]="
          user() ? 'Modifier l\'utilisateur' : 'Créer un nouvel utilisateur'
        "
        [description]="
          'Renseigner le champ ci-dessous pour ' +
          (user() ? 'modifier l\'utilisateur' : 'créér un nouvel utilisateur')
        "
      ></default-modal-header>
    </ng-container>

    <ng-container body>
      <form
        [formGroup]="registerForm"
        (ngSubmit)="onSubmit()"
        class="resource-form"
        id="admin-creation-form"
      >
        <article>
          <mat-label>Entrer l'adresse électronique *</mat-label>
          <mat-form-field color="primary" appearance="outline">
            <input
              matInput
              formControlName="email"
              placeholder="Entrez l'adresse mail"
            />
            <mat-error
              *ngIf="registerForm.get('email')?.getError('httpError') as error"
              [innerHtml]="error"
            >
            </mat-error>
          </mat-form-field>
        </article>
        <article>
          <mat-label>Rôles *</mat-label>
          <ng-select
            [items]="userAdminRoles"
            formControlName="roles"
            [multiple]="true"
            [searchable]="true"
            [clearable]="true"
            placeholder="Sélectionner les rôles"
            [closeOnSelect]="false"
            bindLabel="label"
            bindValue="id"
          >
            <ng-template ng-option-tmp let-item="item">
              {{ item | userRole }}
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              {{ item | userRole }}
            </ng-template>
          </ng-select>
        </article>
      </form>
    </ng-container>

    <footer footer class="resource-form">
      <button
        type="submit"
        [loading]="isLoading"
        [disabled]="!registerForm.valid || isLoading || registerForm.pristine"
        class="btn btn--primary btn--full"
        button
        form="admin-creation-form"
      >
        {{ user() ? "Modifier l'administrateur" : "Envoyer l'invitation" }}
      </button>
    </footer>
  </custom-modal-card>
</main>
